import React, { useContext } from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import { Box } from "@mui/material";

import CodeIcon from "@mui/icons-material/Code";
import CodeOffIcon from "@mui/icons-material/CodeOff";

import { AnimationOnScroll } from "react-animation-on-scroll";
import "animate.css/animate.min.css";

import { ThemeContext } from "../../context";

const Exp = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;
  return (
    <Box
      marginTop="20px"
      display="flex"
      flexDirection="column"
      sx={{ cursor: "default" }}
    >
      <Box
        marginTop="12px"
        fontSize={{ xs: "24px", lg: "25px" }}
        fontWeight={{ xs: "200", lg: "400" }}
      >
        Experience
      </Box>
      <Timeline
        sx={{
          [`& .${timelineItemClasses.root}:before`]: {
            flex: 0,
            padding: 0,
          },
        }}
      >
        <AnimationOnScroll animateIn="animate__fadeIn" duration={1.5}>
          <TimelineItem>
            <TimelineSeparator>
              <TimelineDot
                sx={{
                  backgroundColor: "transparent",
                  color: darkMode ? "#d4af37" : "#616161",
                  boxShadow: "none",
                  filter: darkMode
                    ? "drop-shadow(3px 4px 12px #F4CA3E)"
                    : "drop-shadow(3px 4px 12px #555f61)",
                }}
              >
                <CodeIcon />
              </TimelineDot>
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <Box
                marginTop="12px"
                fontSize={{ xs: "20px", lg: "22px" }}
                fontWeight={{ xs: "200", lg: "400" }}
              >
                Software Developer |
                <span style={{ marginLeft: "4px" }}>.NET</span>
              </Box>
              <Box marginTop="12px">
                <a
                  href="https://paaspay.io/"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    textDecoration: "none",
                    color: darkMode ? "#d4af37" : "#808080",
                  }}
                >
                  PasSPay
                </a>
                <span> · Full-Time</span>
              </Box>
              <Box marginTop="12px"> Feb 2024 - Present</Box>
              <Box marginTop="12px">
                Skills: .NET Core, ASP.NET Web API, Backend Development,
                Databases, AWS, AWS Serverless
              </Box>
            </TimelineContent>
          </TimelineItem>
        </AnimationOnScroll>
        <AnimationOnScroll animateIn="animate__fadeIn" duration={1.6}>
          <TimelineItem>
            <TimelineSeparator>
              <TimelineDot
                sx={{
                  backgroundColor: "transparent",
                  color: darkMode ? "#d4af37" : "#8C979A",
                  boxShadow: "none",
                  filter: darkMode
                    ? "drop-shadow(3px 4px 12px #ffd700)"
                    : "drop-shadow(3px 4px 12px #424242)",
                }}
              >
                <CodeOffIcon />
              </TimelineDot>
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <Box
                marginTop="12px"
                fontSize={{ xs: "20px", lg: "22px" }}
                fontWeight={{ xs: "200", lg: "400" }}
              >
                Software Developer
              </Box>
              <Box marginTop="12px">
                <a
                  href="https://www.google.com/"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    textDecoration: "none",
                    color: darkMode ? "#d4af37" : "#8C979A",
                  }}
                >
                  DigiConnect Pvt.Ltd.
                </a>
                <span> · Full-Time</span>
              </Box>
              <Box marginTop="12px"> Jun 2021 - Nov 2023</Box>
              <Box marginTop="12px">
                Skills: ASP.NET MVC, REST APIs, React.js, Databases
              </Box>
            </TimelineContent>
          </TimelineItem>
        </AnimationOnScroll>
        <AnimationOnScroll animateIn="animate__fadeIn" duration={1.7}>
          <TimelineItem>
            <TimelineSeparator>
              <TimelineDot
                sx={{
                  backgroundColor: "transparent",
                  color: darkMode ? "#d4af37" : "#8C979A",
                  boxShadow: "none",
                  filter: darkMode
                    ? "drop-shadow(3px 4px 12px #ffd700)"
                    : "drop-shadow(3px 4px 12px #424242)",
                }}
              >
                <CodeOffIcon />
              </TimelineDot>
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <Box
                marginTop="12px"
                fontSize={{ xs: "20px", lg: "22px" }}
                fontWeight={{ xs: "200", lg: "400" }}
              >
                Web Developer Intern |
                <span style={{ marginLeft: "4px" }}>Full-Stack</span>
              </Box>
              <Box marginTop="12px">
                <a
                  href="https://www.google.com/"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    textDecoration: "none",
                    color: darkMode ? "#d4af37" : "#9c9c9c",
                  }}
                >
                  DigiConnect Pvt.Ltd.
                </a>
                <span> · Full-Time</span>
              </Box>
              <Box marginTop="12px"> Feb 2021 - May 2021</Box>
              <Box marginTop="12px">
                Skills: .NET Core, ASP.NET Core, Databases, Git
              </Box>
            </TimelineContent>
          </TimelineItem>
        </AnimationOnScroll>
      </Timeline>
    </Box>
  );
};

export default Exp;
